import type { CellarModel } from './cellars.types';
import type { ProductModel } from './products.types';
import type { RemoteCoolerModel } from './remote-coolers.types';

export enum FobStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived'
}

export enum FobType {
  TECFLO_MK1 = 'TecFlo Mk1',
  TECFLO_MK2 = 'TecFlo Mk2',
  STANWELL = 'Stanwell',
  CELLARBUOY = 'Cellarbuoy',
  CASK = 'Cask',
  UNDER_COUNTER = 'Under Counter',
  NO_FOB = 'No FOB',
  CELLAR_PLUS = 'CellarPlus',
  CHILL_POUR = 'ChillPour',
  SMART_DISPENSE = 'SmartDispense',
  CUSTOM = 'Custom'
}

export enum FobGasType {
  CO2 = 'CO2',
  MIX_30_70 = '30/70',
  MIX_60_40 = '60/40',
  N_A = 'N/A'
}

export interface FobModel {
  id: string;
  position: number;
  name: string;
  type: FobType | null;
  gasType: FobGasType | null;
  status: FobStatus;
  maxLines: number | null;
  hygiene: boolean | null;
  pump: boolean | null;
  cellar: CellarModel | string;
  cellarId: string;
  product?: ProductModel;
  remoteCoolers: RemoteCoolerModel[] | string[] | null;
  taps: string[] | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListFobsResponse {
  result: FobModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface CreateFobReq {
  venueId: string | null;
  cellarId: string | null;
  status: FobStatus;
  type: FobType | null;
  gasType: FobGasType | null;
  productId: string | null;
  remoteCoolerIds: string[] | null;
  position: number | null;
  pump: boolean;
  shiftFobs: boolean | null;
}

export interface UpdateFobReq extends CreateFobReq {
  fobId: string | null;
}

export interface DeleteFobReq {
  fobId: string;
}

export interface AutoCompleteFobRes {
  name: string;
}

export interface CreateBulkFobsReq {
  cellarId: string;
  pump: boolean;
  quantity: number;
  status: FobStatus;
  type: FobType | null;
  gasType: FobGasType | null;
  productId: string | null;
  remoteCoolerIds: string[] | null;
}

export type FobsSortingFields = 'name' | 'type' | 'gasType' | 'status' | 'productName';
